import React, { useState, useEffect, useRef } from "react"
import cx from "classnames"
//import _get from 'lodash/get'
import shareIcon from "@/public/icons/share.svg"
import wishIcon from "@/public/icons/wish.svg"
import filledWishIcon from "@/public/icons/wishlist-gray-filled.svg"
import MissingImage from "@/public/images/image-missing.png"
import { getConfig } from "@/constants/config"
import SocialShare from "@/components/SocialShare/v1/SocialShare"
import { useDispatch, useSelector } from "react-redux"
import { addMedia, removeItems } from "@/store/features/favoritesSlice"
import { withTranslation } from "react-i18next"
//import _isEmpty from 'lodash/isEmpty';
import { getProductsBySku } from "@/components/sharedCart/shareCartHelper"
import {
  getPDPUrl,
  isAuthenticated,
  getShortenedUrlwithGeneral,
} from "@/utils/helper"
import {
  selectAuthState,
  setAuthModalVisibility,
} from "@/store/features/authSlice"
import { showToast, selectGenericState } from "@/store/features/genericSlice"

import { addDataLayer, getSocialAnalyticsData } from "../analytics"
import useWindowResize from "@/hooks/useWindowResize"

const ProductTile = ({
  data,
  lite,
  loading,
  staticTexts,
  displayShare,
  displayPrint,
  isModalShow,
  setIsModalShow,
  onInspirationSelect,
  getVarientProductInfo,
  ...props
}) => {
  const [loginFavouriteCallback, setLoginFavouriteCallback] = useState(null)
  const { isAuth, access_token: accessToken } = useSelector(selectAuthState)

  const isFavorite = props.favorites?.find(vl => vl.name["en-US"] === data.id)
    ? true
    : false
  const [showShare, setShowShare] = useState(false)
  const dispatch = useDispatch()
  const CONFIG = getConfig()
  const shareImg = useRef(null)
  const [inspirationUrl, setinspirationUrl] = useState("")
  const [onHover, setOnHover] = useState(false)
  const [width] = useWindowResize()
  const [general, setGeneral] = useState()
  const { toaster = {} } = useSelector(selectGenericState)

  const imageName = data.url_s.split("/")[6]

  useEffect(() => {
    const configFn = async () => {
      const { general } = await getConfig()
      setinspirationUrl(general?.inspirationDetailPath)
      setGeneral(general)
    }
    configFn()
  }, [])
  if (loading)
    return (
      <div className="inspiration-landing-tile--loading">
        <div className="loading-image shimmer"></div>
        <div className="loading-title shimmer"></div>
        <div className="loading-description shimmer"></div>
        <ul className="loading-swatch">
          <li className="shimmer"></li>
          <li className="shimmer"></li>
          <li className="shimmer"></li>
          <li className="shimmer"></li>
          <li className="shimmer"></li>
        </ul>
      </div>
    )

  const handleCallBack = () => {
    addDataLayer({
      title: isFavorite ? "remove favorite" : "add favorite",
      imageName: `${imageName.toLowerCase()}`,
      isFavorite: true,
      cart_ID: props?.cart?.id,
    })
  }
  const handleLogin = e => {
    e.preventDefault()
    e.stopPropagation()
    window.loginFavouriteCallback = () => {
      setLoginFavouriteCallback(e)
    }
    dispatch(setAuthModalVisibility({ show: true }))
  }
  const handleFavorite = e => {
    e.preventDefault()
    e.stopPropagation()
    window.preActiveElement = e.target
    if (isFavorite === true) {
      props.favorites?.map(fav => {
        if (fav.name["en-US"] === data.id) {
          if (!isAuth) {
            handleLogin(e)
          } else {
            dispatch(removeItems({ ids: [fav.id], isDataLayerNeeded: false }))
              .unwrap()
              .then(() => {
                handleCallBack()
                dispatch(
                  showToast({
                    message:
                      getShortenedUrlwithGeneral(
                        toaster?.content?.unfavoriteSuccessMessage,
                        general
                      ) || staticTexts?.removeItem,
                    isVisible: true,
                  })
                )
              })
              .catch(err => {
                dispatch(
                  showToast({
                    message: staticTexts.removeItemError,
                    isVisible: true,
                  })
                )
                handleCallBack()
              })
          }
        }
      })
    } else {
      if (!isAuth) {
        handleLogin(e)
      } else {
        const payload = {
          type: "image",
          name: data?.id,
          url: data?.url_s,
        }
        dispatch(addMedia(payload))
          .unwrap()
          .then(() => {
            handleCallBack()
            dispatch(
              showToast({
                message:
                  getShortenedUrlwithGeneral(
                    toaster?.content?.successMessage,
                    general
                  ) || staticTexts.favSuccessMsg,
                isVisible: true,
              })
            )
          })
          .catch(err => {
            dispatch(
              showToast({
                message: staticTexts.favErrorMsg,
                isVisible: true,
              })
            )
            handleCallBack()
          })
      }
    }
  }

  const handleShare = e => {
    e.preventDefault()
    setShowShare(true)
  }

  const showProductModal = showVal => {
    addDataLayer({
      title: !showVal ? "inspiration image" : "close",
      url: !showVal ? `${data.url_s}`.replace(" ", "%20") : null,
      imageName: `${imageName.toLowerCase()}`,
      isOverlay: showVal ? true : null,
      cart_ID: props?.cart?.id,
    })
    onInspirationSelect(data)
  }

  const onClickVarientItem = async (varient, key) => {
    let sku, category, slug, tileUrl, pageRedirectUrl
    let varientData = varient && varient.split("|")
    if (varientData && varientData.length >= 3) {
      sku = varientData[0]
      category = varientData[1]
      slug = varientData[2]
      tileUrl = await getPDPUrl(category, slug).then(res => res)
      pageRedirectUrl = `${tileUrl}${sku ? "?skuId=" + sku : ""}`
      location.href = decodeURIComponent(pageRedirectUrl)
    }
    data?.ProductMappingSKUID_s &&
      getProductsBySku(
        (data?.ProductMappingSKUID_s).split(",").map(x => x.trim())
      ).then(vdata => {
        addDataLayer({
          title: "sample navigation",
          url: `${decodeURIComponent(pageRedirectUrl)}`,
          tileName: vdata[key]?.name["en-US"].toLowerCase(),
          imageName: `${imageName.toLowerCase()}`,
          productInfo: getVarientProductInfo(vdata[key]),
          cart_ID: props?.cart?.id,
        })
      })
  }
  const setHover = () => {
    document
      .getElementById(`inspiration-landing-tile__wrapper_${data.id}`)
      .classList.add("--hover")
    setOnHover(true)
  }
  const removeHover = () => {
    document
      .getElementById(`inspiration-landing-tile__wrapper_${data.id}`)
      .classList.remove("--hover")
    setOnHover(false)
  }

  return (
    <>
      <div
        className="inspiration-landing-tile__wrapper"
        onMouseLeave={() => setShowShare(false)}
        onFocus={setHover}
        onBlur={removeHover}
        id={`inspiration-landing-tile__wrapper_${data.id}`}
        tabIndex={0}
      >
        {displayShare && (
          <SocialShare
            showModal={showShare}
            id="kf-product-detail"
            onClose={() => {
              setShowShare(false)
              shareImg?.current.focus()
            }}
            shareBtn={shareImg}
            url={`${window.location.origin}${inspirationUrl}?q=${data?.id}`}
            analyticData={JSON.parse(
              getSocialAnalyticsData({
                title: staticTexts.share.toLowerCase(),
                imageName: imageName,
              })
            )}
          />
        )}
        <div
          className={cx({
            "inspiration-landing-tile": true,
            "inspiration-landing-tile--lite": lite,
          })}
        >
          <div className="inspiration-landing-tile__share">
            <div
              className="inspiration-landing-tile__share-icon"
              onClick={handleFavorite}
              aria-hidden={width > 1024 ? (onHover ? false : true) : false}
              tabIndex="0"
              aria-label={staticTexts.wishlist}
              role="button"
            >
              <img
                src={isFavorite ? filledWishIcon.src : wishIcon.src}
                alt={staticTexts.wishlist}
                role="presentation"
              />
            </div>
            {displayShare && (
              <div
                className="inspiration-landing-tile__share-icon inspiration-landing-tile__shareicon"
                ref={shareImg}
                onClick={handleShare}
                tabIndex="0"
                aria-label={staticTexts.share}
                aria-hidden={width > 1024 ? (onHover ? false : true) : false}
                role="button"
              >
                <img
                  src={shareIcon.src}
                  alt={staticTexts.share}
                  role="presentation"
                />
              </div>
            )}
          </div>
          <div
            onClick={() => {
              showProductModal(isModalShow)
            }}
            className="inspiration-landing-tile__image"
            aria-label={data?.title_s}
          >
            <div className="inspiration-landing-tile__image" tabIndex="-1">
              <img
                key={data.id}
                onError={e => (e.target.src = MissingImage.src)}
                src={data.url_s}
                className="inspiration-landing-tile__image--hover"
                alt={data.url_s}
              />
            </div>
          </div>
          {data?.productDetailsList_ss?.length > 0 && (
            <div className="inspiration-landing-tile__varient-list">
              {data?.productDetailsList_ss?.slice(0, 4).map((product, key) => {
                if (key === 3) {
                  return (
                    <div
                      key={key}
                      className="inspiration-landing-tile__image__varient-loadmore"
                    >
                      {`+${
                        data?.productDetailsList_ss.length - 3
                      } more products`}
                    </div>
                  )
                } else {
                  return (
                    <div
                      key={key}
                      className="inspiration-landing-tile__image__varient"
                      onClick={() => {
                        onClickVarientItem(data.productDetailsList_ss[key], key)
                      }}
                    >
                      <img
                        key={key}
                        onError={e => (e.target.src = MissingImage?.src)}
                        src={
                          data?.productImagesList_ss
                            ? data.productImagesList_ss[key]
                                ?.split("|")
                                ?.pop() || MissingImage
                            : MissingImage
                        }
                        className="inspiration-landing-tile__image__varient-image"
                        alt="No Image"
                      />
                    </div>
                  )
                }
              })}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default ProductTile
